export default "__VITE_ASSET__CjkcbxYO__"